<div class="file-report">

  <span class="file-name">
    {{ file?.name || 'No file selected' }}
  </span>
  <label class="file-label" for="fileUpload">Choose report excel</label>
  <input type="file" class="file-input" (change)="onChange($event)" #fileUpload id="fileUpload" />
  <br><br>
  <button  mat-flat-button class="upload-button" (click)="onUpload()">generate report</button>
<!--              <button mat-flat-button color="primary" (click)="completeCreation()">Create Test</button>-->

</div>
